<template>
  <div v-loading="form.processing" class="organization-form">
    <form @submit.prevent="handleFormSubmit">
      <form-group id="organization-status" label="Estado de la Organización" :errors="form.errors">
        <el-switch
          v-model="organizationStatus"
          :active-text="organizationStatus ? 'Activa' : 'Inactiva'" />
      </form-group>
      <form-group id="organization-rut" label="Rut de la Organización" :errors="form.errors">
        <app-rut-input
          v-model="form.data.rut"
          class="form-control"
          :readonly="disableRutChange"
          type="text" />
      </form-group>
      <form-group
        v-if="source === 'midas'"
        id="organization-code"
        label="Código de la Organización"
        :errors="form.errors">
        <input
          v-model="form.data.code"
          class="form-control"
          type="text">
      </form-group>
      <form-group
        v-if="availableOrganizationTypes"
        id="organization-type"
        label="Tipo de la Organización"
        :errors="form.errors">
        <select v-model="form.data.type" :readonly="!form.data.source" class="form-control">
          <option v-for="organizationType in availableOrganizationTypes" :key="organizationType" :value="organizationType">
            {{ organizationType }}
          </option>
        </select>
      </form-group>
      <form-group id="organization-name" label="Nombre de la Organización" :errors="form.errors">
        <input
          v-model="form.data.name"
          maxlength="150"
          class="form-control"
          type="text">
      </form-group>
      <form-group id="organization-address" label="Dirección de la Organización" :errors="form.errors">
        <input
          v-model="form.data.address"
          class="form-control"
          maxlength="100"
          type="text">
      </form-group>
      <button class="btn btn-primary">
        Guardar
      </button>
    </form>
  </div>
</template>

<script>
import FormGroup from '@/components/FormGroup';
import ErrorHelper from '@/helpers/error';
import OrganizationTypes from '@/assets/constants/organization-types';
import AppRutInput from '@/components/AppRutInput';

export default {
  name: 'OrganizationForm',
  components: {
    AppRutInput,
    FormGroup
  },
  props: {
    organization: {
      type: Object,
      default() {
        return {};
      }
    },
    source: {
      type: String,
      default: 'midas'
    }
  },
  data() {
    return {
      form: {
        data: Object.assign({
          source: this.source
        }, this.organization),
        errors: {},
        processing: false
      },
      organizationSources: [
        {
          code: 'midas',
          name: 'Midas'
        },
        {
          code: 'medical_center',
          name: 'Centro Médico'
        }
      ]
    };
  },
  computed: {
    disableRutChange() {
      return this.organization.uuid;
    },
    organizationStatus: {
      get() {
        return this.form.data.status === 'active';
      },
      set(value) {
        this.form.data.status = value ? 'active' : 'inactive';
      }
    },
    availableOrganizationTypes() {
      return this.form.data.source ? OrganizationTypes[this.form.data.source] : null;
    }
  },
  methods: {
    handleFormSubmit() {
      const formData = Object.assign({}, this.form.data);
      this.form.processing = true;
      this.form.errors = {};
      this.$store.dispatch('saveOrganization', formData)
        .then(organization => {
          this.$emit('organization-saved', organization);
        })
        .catch(e => {
          this.form.errors = ErrorHelper.mapErrorFields(e.response.data, {
            id: 'organization-id',
            source: 'organization-source',
            code: 'organization-code',
            type: 'organization-type',
            name: 'organization-name',
            address: 'organization-address',
            rut: 'organization-rut',
            status: 'organization-status'
          });
        })
        .finally(() => {
          this.form.processing = false;
        });
    }
  }
};

</script>

<style lang="scss">
.organization-form {
  form {
    display: flex;
    flex-direction: column;

    button {
      align-self: end;
    }
  }
}
</style>
